/**
 * Picks `x-link-id` for widget API calls. The URL always wins so a previous
 * tab's persisted/expired link cannot authenticate catalog/pre-quote
 * (header-only endpoints) while the address bar shows a new magic link.
 */
export function resolveXLinkIdHeader(args: {
  urlLinkId: string | null;
  currentLinkId: string | null;
  persistedLinkId: string | null;
}): string | null {
  return args.urlLinkId ?? args.currentLinkId ?? args.persistedLinkId;
}
